module.exports = __webpack_public_path__ + "img/paper_negative.879840ae.svg";